import { api } from "./client"

export type ThreadSummary = {
  id: string
  subject: string | null
  last_message_at: string
  created_at: string
  application_id: string | null
  candidate: { id: string; full_name: string; email: string } | null
  job: { id: string; title: string } | null
  last_preview: string | null
}

export type ThreadMessage = {
  id: string
  thread_id: string
  direction: "inbound" | "outbound"
  from_email: string
  to_email: string
  subject: string | null
  body_text: string | null
  body_html: string | null
  received_at: string
}

export type ThreadDetail = ThreadSummary & { messages: ThreadMessage[] }

export const inboxApi = {
  list: () => api<{ data: ThreadSummary[] }>("/inbox/threads"),
  get: (id: string) => api<{ data: ThreadDetail }>(`/inbox/threads/${id}`),
  create: (body: { application_id: string; subject: string; body: string }) =>
    api<{ ok: boolean; data: { thread_id: string } }>("/inbox/threads", {
      method: "POST",
      body,
    }),
  reply: (id: string, body: { body: string }) =>
    api<{ ok: boolean }>(`/inbox/threads/${id}/reply`, { method: "POST", body }),
}
